var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8Z",
    stroke: "#6582BA",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8C7 7.44772 7.44772 7 8 7C8.55228 7 9 7.44772 9 8L9 11C9 11.5523 8.55228 12 8 12C7.44771 12 7 11.5523 7 11L7 8Z",
    fill: "#6582BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5C7 4.44772 7.44772 4 8 4C8.55228 4 9 4.44772 9 5C9 5.55229 8.55228 6 8 6C7.44771 6 7 5.55228 7 5Z",
    fill: "#6582BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNInfo);
export default __webpack_public_path__ + "static/media/icon-n-info.52d2b766aabc05cd135da1d7e7d6a623.svg";
export { ForwardRef as ReactComponent };